const PERMISSION_CACHE_KEY = "mes.permissions.v1";

function normalizePermissions(value) {
  if (!Array.isArray(value)) return null;

  return [...new Set(value.filter((permission) => typeof permission === "string" && permission))];
}

export function readPermissionSessionCache(storage) {
  try {
    const raw = storage?.getItem(PERMISSION_CACHE_KEY);
    if (!raw) return null;

    const cached = JSON.parse(raw);
    return normalizePermissions(cached?.permissions);
  } catch (_) {
    return null;
  }
}

export function writePermissionSessionCache(storage, permissions) {
  const normalized = normalizePermissions(permissions);
  if (normalized === null) return;

  try {
    storage?.setItem(
      PERMISSION_CACHE_KEY,
      JSON.stringify({ permissions: normalized }),
    );
  } catch (_) {
    // Brak sessionStorage nie może blokować logowania ani nawigacji.
  }
}

export function clearPermissionSessionCache(storage) {
  try {
    storage?.removeItem(PERMISSION_CACHE_KEY);
  } catch (_) {
    // Czyszczenie stanu aplikacji pozostaje skuteczne bez dostępu do storage.
  }
}

export function permissionsAfterFailedRefresh(permissions, permissionsLoaded) {
  if (!permissionsLoaded) return [];
  return normalizePermissions(permissions) ?? [];
}
